import { Routes } from '@angular/router';

export const routes: Routes = [
    { 
        path: 'order', 
        loadChildren: () => import('./modules/onboarding-wf/onboarding-wf.routes').then(m => m.onboardingWfRoutes) 
    },
    { 
        path: '', 
        loadComponent: () => import('./modules/plans/plans.component').then(m => m.PlansComponent) 
    }
];
